import { imprint, privacy, termsOfService } from '@e2m-customer-portal/core';
import { useSidebarContext } from '@e2m-customer-portal/hooks';
import { Typography } from '@mui/material';
import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';
import { makeStyles } from 'tss-react/mui-compat';

const useStyles = makeStyles()((theme) => ({
  root: {
    backgroundColor: theme.palette.background.default,
    display: 'flex',
    flexWrap: 'wrap',
    columnGap: theme.spacing(3),
    rowGap: theme.spacing(1.5),
    alignItems: 'center',
    marginTop: 'auto',
    paddingLeft: theme.spacing(6),
    paddingRight: theme.spacing(6),
    paddingTop: theme.spacing(1.5),
    paddingBottom: theme.spacing(1.5),
    fontSize: '0.75rem',
    color: '#555555',
    zIndex: theme.zIndex.drawer - 1,
  },
  link: {
    color: 'inherit',
    textDecoration: 'none',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
}));

export function Footer(): ReactElement {
  const { classes } = useStyles();
  const [{ width: sidebarWidth }] = useSidebarContext();
  const [t] = useTranslation();

  return (
    <Typography component="footer" className={classes.root} style={{ marginLeft: sidebarWidth }}>
      <div className="grow">{t('FOOTER_COPYRIGHT', { date: new Date() })}</div>

      <Link to={imprint.getLink()} className={classes.link}>
        {t('FOOTER_IMPRINT')}
      </Link>

      <Link to={termsOfService.getLink()} className={classes.link}>
        {t('FOOTER_TERMS_OF_SERVICE')}
      </Link>

      <Link to={privacy.getLink()} className={classes.link}>
        {t('FOOTER_DATA_PRIVACY')}
      </Link>
    </Typography>
  );
}
